import React, { useContext, useState } from 'react';

import { Box, Button, Typography } from '@mui/material';

import PropTypes from 'prop-types';

import Axios from '../../../Assets/Axios/Axios';

import ToastContext from '../../../Context/ToastContext';

import CardLayout from '../../../Components/CardLayout';

import { COLORS } from '../../../Constant/COLORS';
import { ORDER_STATUS } from '../../../Constant/Enums';

import AskAdvanceModal from './../Modals/AskAdvance';

import { UpdateOrderStatus } from '../../../Server/Mutation/index';

function JobRequestsCard({ data, updateParentJobsRequests }) {
  const [advanceModelVisible, setAdvanceModelVisible] = useState(false);

  const { showToastMessage } = useContext(ToastContext);

  /** @param { "ACCEPT" | "REJECT" } action */
  async function handleClickAction(action) {
    const orderStatus = action === 'ACCEPT' ? ORDER_STATUS.ACCEPTED : ORDER_STATUS.REJECTED;

    // const query = UpdateOrderStatus({ orderStatus, orderUniqueID: data.id });
    // const { errors } = await Axios({ query });

    // if (errors) {
    //   showToastMessage('Oops! Something went wrong!,Operation failed');
    //   return undefined;
    // }

    showToastMessage(`Job ${action === 'ACCEPT' ? 'Accepted' : 'Rejected'}`, 'success');
    updateParentJobsRequests();
  }

  return (
    <>
      <CardLayout>
        <Box
          alignItems='center'
          gap={2}
          display='grid'
          gridTemplateAreas={{
            xs: "'name' 'data' 'actions'",
            md: "'name actions' 'data data'",
          }}>
          <Typography
            gridArea='name'
            variant='h6'
            fontWeight={600}
            color={COLORS.blue}
            variantMapping={{ h6: 'p' }}>
            {data.name}
          </Typography>

          <Box gridArea='actions' display='grid' gap={2} gridTemplateColumns='1fr 1fr'>
            <Button color='green' onClick={() => handleClickAction('ACCEPT')}>
              Accept
            </Button>

            <Button color='red' onClick={() => handleClickAction('REJECT')}>
              Reject
            </Button>
          </Box>

          <Box
            gridArea='data'
            display='grid'
            gridTemplateColumns={{ xs: 'auto', sm: 'auto 1fr' }}
            columnGap={2}
            rowGap={1}>
            <Typography color={COLORS.black}>Reference Id</Typography>
            <Typography fontWeight={500}>{data.referenceId}</Typography>

            <Typography color={COLORS.black}>Service Place</Typography>
            <Typography fontWeight={500}>{data.place}</Typography>

            <Typography color={COLORS.black}>Event Date & Time</Typography>
            <Typography fontWeight={500}>{data.date}</Typography>

            <Typography color={COLORS.black}>Phone Number</Typography>
            <Typography fontWeight={500}>{data.phoneNumber}</Typography>

            <Typography color={COLORS.black}>Package</Typography>
            <Typography fontWeight={500}>{data.package.name}</Typography>

            <Typography color={COLORS.black}>Price</Typography>
            <Typography fontWeight={500}>{data.package.price}</Typography>

            <Typography color={COLORS.black}>Note</Typography>
            <Typography fontWeight={500}>{data.note}</Typography>
          </Box>
        </Box>
      </CardLayout>
      <AskAdvanceModal open={advanceModelVisible} onClose={() => setAdvanceModelVisible(false)} />
    </>
  );
}

JobRequestsCard.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    place: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    package: PropTypes.shape({
      name: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
    }).isRequired,
    referenceId: PropTypes.string.isRequired,
  }),
  updateParentJobsRequests: PropTypes.func,
};

export default JobRequestsCard;
